import { render, staticRenderFns } from "./BuildingSpotRole.global.vue?vue&type=template&id=4815808e&lang=pug&"
import script from "./BuildingSpotRole.global.vue?vue&type=script&lang=ts&"
export * from "./BuildingSpotRole.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports